
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Username', value: 'username'},
  { text: 'Fullname', value: 'fullname'},
  { text: 'Role', value: 'role'},
  { text: 'Created At', value: 'created_at'},
  { text: 'Last Login', value: 'last_login_at'},
  { text: 'Status', value: 'status_label', align: 'center', textAlign: 'text-center'},
  { text: 'Actions', value: 'action', width: '100'},
]);

export const editedItem = {
  username: '',
  fullname: '',
  email: '',
  mobile_phone: '',
  role: '',
  status: '',
  password: '',
  passwordConfirmation: '',
};

export const defaultItem = {
  fullname: '',
  email: '',
  username: '',
  mobile_phone: '',
  role: '',
  status: '',
  password: '',
  passwordConfirmation: '',
};

export const search = {
  username: '',
  fullname: '',
  role: '',
  created_at: null,
  last_login_at: null,
  status: '',
};

